<div nz-row class="validation-main-wrapper" nzGutter="16">
    <div nz-col nzSpan="4">
        <form nz-form [formGroup]="searchForm" [nzLayout]="'vertical'">
            <nz-form-item>
                <nz-form-label [nzSpan]="null">Client/Carrier Id</nz-form-label>
                <nz-form-control  [nzSpan]="null" nzErrorTip="Please input your username!">
                    <input nz-input formControlName="clientId" />
                </nz-form-control>
            </nz-form-item>

            <nz-form-item>
                <nz-form-label [nzSpan]="null">Client</nz-form-label>
                <nz-form-control  [nzSpan]="null" nzErrorTip="Please input your username!">
                    <ng-select 
                        [addTag]="addTagFn"
                        [searchWhileComposing]="true" 
                        [searchable]="true" 
                        [multiple]="true" 
                        [clearSearchOnAdd]="true"
                        [virtualScroll]="true"   
                        formControlName="client"  class="q-dropdown-rule">         
                        
                        <ng-option *ngFor="let c of clientList" [value]="c.name">{{ c.name }}</ng-option>

                    </ng-select>
                </nz-form-control>
            </nz-form-item>

            <nz-form-item>
                <nz-form-label [nzSpan]="null">Client Division</nz-form-label>
                <nz-form-control  [nzSpan]="null" nzErrorTip="Please input your username!">
                    <ng-select 
                        [searchWhileComposing]="true" 
                        [searchable]="true" 
                        [multiple]="true" 
                        [clearSearchOnAdd]="true"
                        [virtualScroll]="true"   
                        formControlName="clientDivision"  class="q-dropdown-rule">    
                        
                        <ng-option *ngFor="let c of clientDivisionList" [value]="c.name">{{ c.name }}</ng-option>

                    </ng-select>
                </nz-form-control>
            </nz-form-item>

            <nz-form-item>
                <nz-form-label [nzSpan]="null">Client Location</nz-form-label>
                <nz-form-control  [nzSpan]="null" nzErrorTip="Please input your username!">
                    <ng-select 
                        [searchWhileComposing]="true" 
                        [searchable]="true" 
                        [multiple]="true" 
                        [clearSearchOnAdd]="true"
                        [virtualScroll]="true"   
                        formControlName="clientLocation"  class="q-dropdown-rule">     
                        
                        <ng-option *ngFor="let c of clientLocationList" [value]="c.name">{{ c.name }}</ng-option>

                    </ng-select>
                    
                </nz-form-control>
            </nz-form-item>

            
            <nz-form-item>
                <nz-form-label [nzSpan]="null">Client Region</nz-form-label>
                <nz-form-control  [nzSpan]="null" nzErrorTip="Please input your username!">
                    <ng-select 
                        [searchWhileComposing]="true" 
                        [searchable]="true" 
                        [multiple]="true" 
                        [clearSearchOnAdd]="true"
                        [virtualScroll]="true"   
                        formControlName="clientRegion" class="q-dropdown-rule">
                        
                        <ng-option *ngFor="let c of clientRegionList" [value]="c.name">{{ c.name }}</ng-option>

                    </ng-select>
                </nz-form-control>
            </nz-form-item>

            <nz-form-item>
                <nz-form-label [nzSpan]="null">Client Country</nz-form-label>
                <nz-form-control  [nzSpan]="null" nzErrorTip="Please input your username!">
                    <ng-select 
                        [searchWhileComposing]="true" 
                        [searchable]="true" 
                        [multiple]="true" 
                        [clearSearchOnAdd]="true"
                        [virtualScroll]="true"   
                        formControlName="clientCountry" class="q-dropdown-rule">
                        
                        <ng-option *ngFor="let c of clientCountryList" [value]="c.name">{{ c.name }}</ng-option>

                    </ng-select>
                </nz-form-control>
            </nz-form-item>

            <nz-form-item>
                <nz-form-label [nzSpan]="null">Carrier SCAC</nz-form-label>
                <nz-form-control  [nzSpan]="null" nzErrorTip="Please input your username!">
                    <ng-select 
                        [searchWhileComposing]="true" 
                        [searchable]="true" 
                        [multiple]="true" 
                        [clearSearchOnAdd]="true"
                        [virtualScroll]="true"   
                        formControlName="carrierScac"  class="q-dropdown-rule">
                        
                        <ng-option *ngFor="let c of carrierScacList" [value]="c.name">{{ c.name }}</ng-option>

                    </ng-select>
                </nz-form-control>
            </nz-form-item>

            <nz-form-item>
                <nz-form-label [nzSpan]="null">Carrier Location</nz-form-label>
                <nz-form-control  [nzSpan]="null" nzErrorTip="Please input your username!">
                    <ng-select 
                        [searchWhileComposing]="true" 
                        [searchable]="true" 
                        [multiple]="true" 
                        [clearSearchOnAdd]="true"
                        [virtualScroll]="true"   
                        formControlName="carrierLocation" class="q-dropdown-rule">
                        
                        <ng-option *ngFor="let c of carrrierLocationList" [value]="c.name">{{ c.name }}</ng-option>

                    </ng-select>
                </nz-form-control>
            </nz-form-item>

            <nz-form-item>
                <nz-form-label [nzSpan]="null">Status</nz-form-label>
                <nz-form-control  [nzSpan]="null" nzErrorTip="Please input status!">
                    <ng-select 
                        [searchWhileComposing]="true" 
                        [searchable]="true"
                        [clearSearchOnAdd]="true"
                        [virtualScroll]="true"   
                        formControlName="status" class="q-dropdown-rule">
                        
                        <ng-option *ngFor="let c of statusList" [value]="c">{{ c }}</ng-option>

                    </ng-select>
                </nz-form-control>
            </nz-form-item>

            <div class="btn-controls">
                <button class="ctgfa-btn ctgfa-primary-btn" (click)="search()"><span><span class="custom-btn-icon" nz-icon nzType="plus" nzTheme="outline"></span>Search</span></button>
                <button class="ctgfa-btn ctgfa-delete-btn" (click)="clear()"><span><span nz-icon class="custom-btn-icon"nzType="clear" nzTheme="outline"></span>Clear</span></button>
            </div>
        </form>
    </div>

    <div nz-col nzSpan="20">
        <div class="card" style="background: none;">
            <my-tabsautopass class="ap-main-wrapper" (closeAllTabsEmit)="closeAllTabsEmit($event)">
              <my-tabautopass [tabTitle]="'RULES'">
                <div class="tab-content validation-btn-group">
                    
                    <button class="ctgfa-btn ctgfa-primary-btn" >Export</button>
                    <button class="ctgfa-btn ctgfa-primary-btn" >Upload</button>
                    <button id="validationDeleteId" class="ctgfa-btn ctgfa-delete-btn"  nz-popconfirm nzPopconfirmTitle="Are you sure delete this filter?"  (nzOnConfirm)="deleteFilter()"><span><span nz-icon class="custom-btn-icon" nzType="clear" nzTheme="outline"></span>Delete</span></button>


                    <button id="validationAddfilterBtnId" class="ctgfa-btn ctgfa-primary-btn filter-btn" (click)="addFilter()"><i class="mdi mdi-plus" aria-hidden="true"></i> Add Filter</button>
                    <button class="ctgfa-btn ctgfa-primary-btn filter-btn" (click)="search()"><span><span nz-icon class="custom-btn-icon" nzType="reload" nzTheme="outline"></span>Refresh</span></button>
                    
                    <div>

                        <div class="select-all-container">
                            <label nz-checkbox [(ngModel)]="selectAll" (ngModelChange)="selectAllChange($event)">Select All</label>
                        </div>

                        <nz-table
                            #virtualTable
                            [nzBordered]="true"
                            [nzVirtualItemSize]="54"
                            [nzData]="validationFilter"
                            [nzVirtualForTrackBy]="trackByIndex"
                            [nzFrontPagination]="true"
                            [nzShowPagination]="true"
                            [nzSize]="'small'"
                            [nzScroll]="{ x: '1200px', y: '340px' }"
                            [nzPageIndex]="1" [nzTotal]="50">
                            <thead>
                                <tr>
                                    <th class="v-table-head" nzWidth="150px"></th>
                                    <th class="v-table-head" nzWidth="220px">Rule ID</th>
                                    <th class="v-table-head">Filter Name</th>                          
                                </tr>
                            </thead>
                            <tbody>
                            <ng-template nz-virtual-scroll let-data let-index="index">
                                <tr>
                                    <td nzWidth="150px" style="display: flex; justify-content: space-around;">
                                        <button class="validation-edit-btn" (click)="editFilter(data)">Edit</button>
                                        <label nz-checkbox [(ngModel)]="data.checked"></label>
                                    </td>
                                    <td nzWidth="220px">{{ data.Id }}</td>
                                    <td>{{ data.FilterName }}</td>
                                </tr>
                            </ng-template>
                            </tbody>
                        </nz-table>
                        </div>
                </div>

              </my-tabautopass>
        
           
        
           </my-tabsautopass>
        </div>
    </div>
</div>

<ng-template let-filter="filter" #autopassform>
    <validationform [filter]="filter"></validationform>
</ng-template>
